import { IsInt, IsNotEmpty, IsOptional, IsString, MaxLength } from 'class-validator';

export class ProfileCategoryUpdateRequest {
    @IsOptional()
    @IsInt()
    public id?: number;

    @IsString()
    @IsNotEmpty()
    @MaxLength(255)
    public name: string;

    @IsInt()
    public sort: number;

    constructor(data?: Partial<ProfileCategoryUpdateRequest>) {
        this.id = data && data.id;
        this.name = data && data.name;
        this.sort = data && data.sort;
    }
}
